import * as React from "react";
import * as kea from "kea-react";
import * as models from "app/models/requireme";
import { selectores } from "app/main/std";
import { SelectorSimpleFactory} from "app/features/selectores/logic";
import { observeResource } from "kea-resource";
import { setState } from "app/resources/globals";
import * as resources from "app/resources";
import { Observable } from "rxjs";

type Entity = models.GuiaPPFiltro
type DataSelector = models.ItemsSelectorTarifasPP

interface Props {
    value: Entity;
    onChange: (x: Entity) => void;
    ClienteReadonly: boolean;
}

export class FiltroGuiaPP extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    getField = kea.formfields(() => this.props);

    itemsSelectorObs  = (x) => observeResource(resources.PaquetePP.QueryGuiasPPSelectorTarifa, x);

    onChange = () => {
        this.props.value.IdTarifaPP = null;
    }
    onAgregar = () => {
    }

    render( ){
        const Cliente = this.getField(selectores.Cliente);
        const SiNo = this.getField(selectores.SiNo);
        const Tarifa = this.getField(SelectorSimpleFactory( this.itemsSelectorObs(this.props.value),x => x.IdTarifaPP, x => x.NombreTarifaPP));
        return (
            kea.autogrid(4, [
                <Cliente readonly={this.props.ClienteReadonly} onAgregar={this.onAgregar} field="IdCliente" label="Cliente"/>,
                //<SiNo field="AplicaPaquete" label="Apli. paq." />,
                //<SiNo field="AplicaSobre" label="Apli. sobr." />,
                <Tarifa field="IdTarifaPP" label="Tarifa PP" />
            ])
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guiapp/listado/filtro.tsx